import React from 'react';
import { partnerLogos } from '../mock';

export default function LogoMarquee() {
  const list = [...partnerLogos, ...partnerLogos];
  return (
    <section className="py-10 border-y border-slate-200 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs uppercase tracking-[0.25em] text-slate-500 font-medium">Accepting all major payment methods</p>
      </div>
      <div className="mt-6 relative">
        <div className="marquee-track flex gap-16 items-center whitespace-nowrap w-max">
          {list.map((l, i) => (
            <div key={i} className="text-2xl font-semibold text-slate-400 tracking-wide">
              {l}
            </div>
          ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent pointer-events-none"/>
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent pointer-events-none"/>
      </div>
    </section>
  );
}
